import * as types from "./salesTaxesActionTypes";
import api from "./salesTaxesApi";

export function getTaxes(
  model,
  offset = 0,
  limit = 10,
  q = "",
  sortBy = [],
  filters,
  customHeaders
) {
  return {
    type: types.GET_TAXES,
    model,
    promise: api.getTaxes(
      model,
      offset,
      limit,
      q,
      sortBy,
      filters,
      customHeaders
    ),
    payload: { model },
  };
}

export function updateTaxes(model, data, customHeaders) {
  return {
    type: types.UPDATE_TAXES,
    model,
    promise: api.updateTaxes(model, data, customHeaders),
  };
}



// WEBPACK FOOTER //
// ./src/components/dashboard/sales-taxes/salesTaxesActions.js